import moment from "moment";

export const formatProductionTime = (value) => {
  if (value == null || value === "") return "";
  if (typeof value === "number") {
    return moment.unix(value).format("YYYY-MM-DD HH:mm:ss");
  }
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD HH:mm:ss") : String(value);
};

export const formatLocationLabel = (value) => {
  if (value === 1) return "Yes";
  if (value === 0) return "No";
  if (value == null || value === "") return "";
  return String(value);
};

export const formatCoordinate = (value) => {
  if (value == null || value === "") return "";
  const num = Number(value);
  return Number.isFinite(num) ? String(num) : "";
};

export const getProductionPlates = (production) =>
  production?.plates || production?.Plates || [];

export const PLATE_PRODUCTION_EXPORT_HEADERS = [
  "Name",
  "Description",
  "Production Time",
  "Plate Name",
  "Plate Description",
  "Code",
  "OEM",
  "Dealer",
  "Device",
  "Access Item Name",
  "Location",
  "Latitude",
  "Longitude",
];

export const buildPlateProductionExportRow = (production, plate) => [
  production.ProductionName || "",
  production.ProductionDesc || "",
  formatProductionTime(production.ProductionTime),
  plate?.PlateName || "",
  plate?.PlateDesc || "",
  plate?.PlateCode || "",
  plate?.OemName || "",
  plate?.DealerName || "",
  plate?.DeviceName || "",
  plate?.ItemName || "",
  formatLocationLabel(plate?.Location),
  formatCoordinate(plate?.Latitude),
  formatCoordinate(plate?.Longitude),
];

export const buildPlateProductionExportRows = (responseData) => {
  if (!responseData) {
    throw new Error("Plate production data is null or undefined");
  }

  const dataArray = responseData.data || responseData;

  if (!Array.isArray(dataArray)) {
    throw new Error("Expected data to be an array");
  }

  const rows = [];

  dataArray.forEach((production) => {
    const plates = getProductionPlates(production);

    if (!plates.length) {
      rows.push([
        production.ProductionName || "",
        production.ProductionDesc || "",
        formatProductionTime(production.ProductionTime),
        "No plates",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ]);
      return;
    }

    plates.forEach((plate) => {
      rows.push(buildPlateProductionExportRow(production, plate));
    });
  });

  return rows;
};
